import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarListItem from './VeltCommentsSidebarListItem/VeltCommentsSidebarListItem';
var VeltCommentsSidebarList = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarList.Item = VeltCommentsSidebarListItem;
export default VeltCommentsSidebarList;
